import { render, staticRenderFns } from "./ubc.vue?vue&type=template&id=7f7a0be0&scoped=true&v-once=true"
import script from "./ubc.vue?vue&type=script&lang=js"
export * from "./ubc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a0be0",
  null
  
)

export default component.exports